import MontaIcon from "#/assets/origins/source-monta.svg?url";
import SmartIcon from "#/assets/origins/source-smart.svg?url";
import FarIcon from "#/assets/origins/source-far-color.svg?url";
import AzadIcon from "#/assets/origins/source-azad-color.svg?url";
import ExamIcon from "#/assets/origins/source-exam-color.svg?url";
import KaheIcon from "#/assets/origins/source-kahe-color.svg?url";
import NanoIcon from "#/assets/origins/source-nano-color.svg?url";
import DaryaftIcon from "#/assets/origins/source-daryaft-color.svg?url";
import RobocupIcon from "#/assets/origins/source-robocup-color.svg?url";
import SanjeshIcon from "#/assets/origins/source-sanjesh-color.svg?url";
import DomesticIcon from "#/assets/origins/source-domestic-color.svg?url";
import GolvazheIcon from "#/assets/origins/source-golvazhe-color.svg?url";
import OlympiadIcon from "#/assets/origins/source-olympiad-color.svg?url";
import SourceAbroadIcon from "#/assets/origins/source-abroad-color.svg?url";
import DrshekariIcon from "#/assets/origins/source-drshakeri-color.svg?url";
import KhoshkhanIcon from "#/assets/origins/source-khoshkhan-color.svg?url";
import TakhtesiaIcon from "#/assets/origins/source-takhtesia-color.svg?url";
import DoneCircleIcon from "#/assets/descriptiveQuestion/done-circle.svg?url";
import InfoCircleIcon from "#/assets/descriptiveQuestion/info-circle.svg?url";
import TizhoushanIcon from "#/assets/origins/source-tizhoushan-color.svg?url";
import FailedCircleIcon from "#/assets/descriptiveQuestion/failed-circle.svg?url";
import InternationalIcon from "#/assets/origins/source-international-color.svg?url";

export const possibleStatus = {
  "-1": {
    className: "skipped",
    title: "اصلا نزدی",
    icon: InfoCircleIcon,
  },
  "0": {
    className: "wrong",
    title: "غلط زدی",
    icon: FailedCircleIcon,
  },
  "1": {
    className: "correct",
    title: "درست زدی",
    icon: DoneCircleIcon,
  },
};

export const origins = [
  {
    id: 10,
    name: "منتا",
    icon: MontaIcon,
  },
  {
    id: 11,
    name: "آزمون‌های آزمایشی کشور",
    icon: "",
  },
  {
    id: 12,
    name: "گاج",
    icon: "",
  },
  {
    id: 13,
    name: "سنجش",
    icon: SanjeshIcon,
  },
  {
    id: 14,
    name: "سبز",
    icon: "",
  },
  {
    id: 20,
    name: "سراسری",
    icon: DomesticIcon,
  },
  {
    id: 21,
    name: "آزاد",
    icon: AzadIcon,
  },
  {
    id: 25,
    name: "آزاد صبح",
    icon: AzadIcon,
  },
  {
    id: 26,
    name: "آزاد عصر",
    icon: AzadIcon,
  },
  {
    id: 30,
    name: "آزمون‌های آزمایشی آموزش و پرورش",
    icon: "",
  },
  {
    id: 97,
    name: "کار در کلاس",
    icon: "",
  },
  {
    id: 98,
    name: "تمرین‌های کتاب",
    icon: "",
  },
  {
    id: 99,
    name: "سوالات امتحانی",
    icon: ExamIcon,
  },
  {
    id: 105,
    name: "سوالات امتحانی خارج کشور",
    icon: ExamIcon,
  },
  {
    id: 110,
    name: "نمونه پایان ترم",
    icon: "",
  },
  {
    id: 120,
    name: "خارج از کشور",
    icon: SourceAbroadIcon,
  },
  {
    id: 130,
    name: "آزمون اساتيد",
    icon: "",
  },
  {
    id: 140,
    name: "آزمون میرر",
    icon: "",
  },
  {
    id: 150,
    name: "مدرسه",
    icon: "",
  },
  {
    id: 50,
    name: "بین المللی",
    icon: InternationalIcon,
  },
  {
    id: 60,
    name: "روبوکاپ",
    icon: RobocupIcon,
  },
  {
    id: 80,
    name: "نمونه دولتی و تیزهوشان",
    icon: TizhoushanIcon,
  },
  {
    id: 90,
    name: "المپیاد",
    icon: OlympiadIcon,
  },
  {
    id: 2000,
    name: "آزمون های گذشته",
    icon: "",
  },
  {
    id: 160,
    name: "خوشخوان",
    icon: KhoshkhanIcon,
  },
  {
    id: 161,
    name: "دريافت",
    icon: DaryaftIcon,
  },
  {
    id: 162,
    name: "فار",
    icon: FarIcon,
  },
  {
    id: 163,
    name: "کاهه",
    icon: KaheIcon,
  },
  {
    id: 164,
    name: "گل واژه",
    icon: GolvazheIcon,
  },
  {
    id: 165,
    name: "نانو",
    icon: NanoIcon,
  },
  {
    id: 166,
    name: "دکتر شاکري",
    icon: DrshekariIcon,
  },
  {
    id: 167,
    name: "تخته سياه",
    icon: TakhtesiaIcon,
  },
  {
    id: 168,
    name: "کاگو",
    icon: "source kago",
  },
  {
    id: 169,
    name: "smart",
    icon: SmartIcon,
  },
  {
    id: 170,
    name: "کاپ",
    icon: "source cup",
  },
  {
    id: 171,
    name: "منتآزمون",
    icon: MontaIcon,
  },
  {
    id: 172,
    name: "خصوصی",
    icon: "",
  },
];
